// extracted by mini-css-extract-plugin
export default {"fieldContainer":"EditCategoryModal_fieldContainer__gwkMB","label":"EditCategoryModal_label__hAZkX"};